import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'bb-temp-back-mobile',
	templateUrl: './bb-temp-back-mobile.component.html'
})

export class BbTempBackMobileComponent {
	@Input() backOnMobile: any;

	constructor(private router: Router) {}

	goBack() {
		this.router.navigate([this.backOnMobile]);
	}
}
